import {CLOSE_DATE, OPEN_DATE} from "../constants/Constants";

export function isOpenPurchases() {
    return Date.now() >= OPEN_DATE && Date.now() <= CLOSE_DATE;
}

export function formatDate(date) {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    if (year < 100) {
        year += 2000
    }

    return [year, month, day].join('-');
}

export function formatItalyDate(date) {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [ day, month, year].join('/');
}